import ApiClient from '../../api/src/ApiClient'
import Cms from "../../cms/src/Cms";
import Storage from "./CategoriesStorage";


export default {
  namespaced: true,

  state: {
    loaded: false,
    list: [],
    listIcons: [],
    selected: null,
    filters: [],
    selectedProd: []
  },

  mutations: {

    list(state, response) {
      let categoryChild = function (category) {
        if (category.image) {
          category.image = Cms.replaceSizePhoto(c.image, 120, 80);
        }
        let childList = category.subcategories.filter(c => c.active == 'Y');
        category.subcategories = childList.map(child => categoryChild(child));
        return category;
      };

      let list = response.data.filter(c => c.active == 'Y');
      state.list = list.map(c => categoryChild(c));
      state.listIcons = state.list.filter(c => c.imageList.length > 0);

      list.sort((a,b)=>{
        if(a.priority>b.priority){
          return -1
        } else {
          return 1
        }
      })


      state.list = list;
      if (!state.loaded) {
        state.selected = Storage.loadParams();
        state.loaded = true;
      }
    },

    selectedProduct(state, payload) {
      state.selectedProd = payload.map(a => a.Id);
    },

    clearSelected(state) {
      state.selectedProd = [];
    }
  },


  actions: {
    setFilters({ state }, data) {
      state.filters = data;
    },



    saveStorage({ state }) {
      Storage.saveParams(state.selected);
    },

    selected({ commit, state }, category) {
      if (category.top) {
        state.selected = category.category;
        this.dispatch('search/selectedCategoryClear', category.category)
      } else {
        state.selected = category.category;
        this.dispatch('search/selectedCategory', category.category)
      }

    },
    async requestData({ commit }) {
      let result = Storage.loadTree();
      if (!result) {
        result = await ApiClient.get('shop/categories');
        Storage.saveTree(result);
      }
      commit('list', result);
    },
    async requestDataForce({ commit }) {
        let result = await ApiClient.get('shop/categories');
        Storage.saveTree(result);
        commit('list', result);
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/categories/src/CategoriesStore.js